import { useEffect, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { createModal } from '@thermon-platforms/thermon-ui-core';
import { Link } from 'react-router-dom';
import { ConfigureDeviceModal } from '../manage-devices';
import useAlarmsStore, { getMaxSeverity } from 'store/alarms';
import useUsersStore from 'store/users';
import useRolesStore from 'store/roles';
import useDevicesStore from 'store/devices';
import { getAllChildDevicesByType, getConfigItem } from 'util/device';


function PanelTableRow({row}) {
  const [alarms, setAlarms] = useState([]);
  const [alarmsStore] = useAlarmsStore();
  const [devicesStore, devicesStoreActions] = useDevicesStore();
  const [, usersStoreActions] = useUsersStore();
  const [rolesStore] = useRolesStore();
  const [detail, setDetail] = useState();
  const LOTO = getConfigItem(row, 'LockoutTagOut');

  function editPanel(panel) {
    const editPanelModal = createModal(<ConfigureDeviceModal device={panel} />);
    editPanelModal.open()
      .then((res) => {
        // Handle side-effects
        devicesStoreActions.forceUpdate();
      })
      .catch(() => {/* no-op */})
  }

  useEffect(() => {
    devicesStoreActions.fetchDetail(row.id).then((detail) => {
      setDetail(detail);
    });
  }, [row]);

  useEffect(() => {
    if (!alarmsStore.alarms.length) {
      return;
    }

    // Check for alarm status on this device
    setAlarms(alarmsStore.alarms.filter(alarm => {
      if (!alarm.deviceId) return false;
      // If alarm is on this device add it
      if (alarm.deviceId == row.id) return true;
      // If this device is in the path of the device with the alarm add it
      const path = devicesStore.shallowDevices.get(alarm.deviceId)?.path.map(d => d.id);
      if (!path) return false;
      return path.includes(row.id);
    }));
  }, [alarmsStore]);

  return (
    <tr key={`panel-row-${row.id}`}>
      <td>
        <span className={
          `status-icon
          ${alarms.length ? 'attention' : ''}
          ${LOTO?.value == 'on' ? 'locked-out' : getMaxSeverity(alarms)}`}
        ></span>
        <Link to={row.id}>{row.name}</Link>
      </td>
      <td>{alarms.length}</td>
      <td>{row.type == 'Panel' ? row.children.length : <>&ndash;</>}</td>
      <td>
        {getAllChildDevicesByType(row, 'Circuit')?.length || 0}
      </td>
      <td>
        {usersStoreActions.checkAccess('CanChangeConfiguration', rolesStore.roles) ? <>
          <button
            className="settings"
            onClick={() => editPanel(detail)}
            data-tooltip-content={t`Panel Settings`}
            data-tooltip-id="control-tooltip"
          >
            <Trans>Settings</Trans>
          </button>
        </> : <></>}
      </td>
    </tr>
  );
}

export default PanelTableRow;
